// ĐỌC CHỮ TỪ PDF CÓ LỚP CHỮ (thư viện sản phẩm Boss — docs/thiet-ke-thu-vien-san-pham.md mục 2). Không thư viện ngoài, không chạy mã
// trong PDF: chỉ đọc đối tượng (kể cả trong luồng đối tượng /ObjStm), giải nén FlateDecode (có trần chống bom), lần theo cây trang, đọc
// lệnh vẽ chữ (Tj TJ ' " + vị trí Td TD Tm T*) và đổi mã chữ ra Unicode bằng bảng ToUnicode của phông (Identity-H 2 byte hoặc 1 byte;
// phông đơn giản không có bảng → Windows-1252). Ngắt dòng khi đường chân chữ đổi; chèn dấu cách khi khoảng trống giữa hai đoạn chữ lớn hơn
// bề rộng chữ (tính từ /W, /Widths). PDF mã hoá → báo có mật khẩu; không ra chữ mà có ảnh → báo là ảnh quét (hãy tải ẢNH); hỏng → lỗi rõ.
// Giới hạn đã biết: phông nhúng KHÔNG có ToUnicode (hiếm, PDF cũ) → chữ có thể sai; bố cục nhiều cột đọc theo thứ tự vẽ.
import { LoiTaiLieu } from "./tai-lieu"; // vòng import an toàn: chỉ dùng bên trong hàm

const GIAI_NEN_TONG_TOI_DA = 60 * 1024 * 1024; // tổng byte giải nén của cả tệp (chống bom)
const TRANG_TOI_DA = 2000;

// Đầu tệp là "%PDF-"; tệp đuôi .pdf được phép có rác trước tiêu đề (≤ 1 KB, trình đọc PDF cũng chấp nhận).
export function laPdf(d: Uint8Array, duoiPdf = false): boolean {
  const dau = new TextDecoder("latin1").decode(d.subarray(0, duoiPdf ? 1024 : 5));
  return dau.includes("%PDF-");
}

// ---------------- từ vựng PDF ----------------
interface Ten { n: string }
interface Chuoi { s: string } // byte (latin1)
interface ThamChieu { r: number }
interface TuDien { d: Record<string, GiaTri> }
interface Lenh { o: string }
type GiaTri = number | boolean | null | Ten | Chuoi | ThamChieu | TuDien | Lenh | GiaTri[];

const laTen = (v: unknown): v is Ten => !!v && typeof v === "object" && "n" in v;
const laChuoi = (v: unknown): v is Chuoi => !!v && typeof v === "object" && "s" in v;
const laThamChieu = (v: unknown): v is ThamChieu => !!v && typeof v === "object" && "r" in v;
const laTuDien = (v: unknown): v is TuDien => !!v && typeof v === "object" && "d" in v;
const laLenh = (v: unknown): v is Lenh => !!v && typeof v === "object" && "o" in v;

const KHOANG_TRANG = new Set([0, 9, 10, 12, 13, 32]);
const PHAN_CACH = new Set("()<>[]{}/%".split("").map((c) => c.charCodeAt(0)));

class DocTu {
  i: number;
  constructor(public s: string, i = 0) { this.i = i; }
  boQua(): void {
    const s = this.s;
    while (this.i < s.length) {
      const c = s.charCodeAt(this.i);
      if (KHOANG_TRANG.has(c)) { this.i++; continue; }
      if (c === 37) { while (this.i < s.length && s[this.i] !== "\n" && s[this.i] !== "\r") this.i++; continue; } // % chú thích
      break;
    }
  }
  tu(): string {
    const st = this.i;
    while (this.i < this.s.length) { const c = this.s.charCodeAt(this.i); if (KHOANG_TRANG.has(c) || PHAN_CACH.has(c)) break; this.i++; }
    return this.s.slice(st, this.i);
  }
  /** Một giá trị (hoặc lệnh). null khi hết. `thamChieu` = cho phép "n g R". */
  giaTri(thamChieu = true): GiaTri | undefined {
    this.boQua();
    const s = this.s;
    if (this.i >= s.length) return undefined;
    const c = s[this.i]!;
    if (c === "<" && s[this.i + 1] === "<") {
      this.i += 2;
      const d: Record<string, GiaTri> = {};
      for (let vong = 0; ; vong++) {
        if (vong > 100_000) throw new Error("từ điển quá lớn");
        this.boQua();
        if (this.i >= s.length) throw new Error("từ điển không đóng");
        if (s[this.i] === ">" && s[this.i + 1] === ">") { this.i += 2; break; }
        const k = this.giaTri(false);
        if (!laTen(k)) { if (k === undefined) throw new Error("từ điển không đóng"); continue; }
        const v = this.giaTri(thamChieu);
        if (v === undefined) throw new Error("từ điển không đóng");
        d[k.n] = v;
      }
      return { d };
    }
    if (c === "[") {
      this.i++;
      const a: GiaTri[] = [];
      for (let vong = 0; ; vong++) {
        if (vong > 1_000_000) throw new Error("mảng quá lớn");
        this.boQua();
        if (this.i >= s.length) throw new Error("mảng không đóng");
        if (s[this.i] === "]") { this.i++; break; }
        const v = this.giaTri(thamChieu);
        if (v === undefined) throw new Error("mảng không đóng");
        a.push(v);
      }
      return a;
    }
    if (c === "(") return { s: this.chuoiThuong() };
    if (c === "<") {
      const het = s.indexOf(">", this.i);
      if (het < 0) throw new Error("chuỗi hex không đóng");
      let hex = s.slice(this.i + 1, het).replace(/[^0-9a-fA-F]/g, "");
      this.i = het + 1;
      if (hex.length % 2) hex += "0";
      let out = "";
      for (let k = 0; k < hex.length; k += 2) out += String.fromCharCode(parseInt(hex.slice(k, k + 2), 16));
      return { s: out };
    }
    if (c === "/") {
      this.i++;
      return { n: this.tu().replace(/#([0-9a-fA-F]{2})/g, (_, h: string) => String.fromCharCode(parseInt(h, 16))) };
    }
    if (c === "]" || c === ">" || c === ")" || c === "{" || c === "}") { this.i++; return { o: c }; }
    const t = this.tu();
    if (!t) { this.i++; return { o: c }; }
    if (/^[+-]?(\d+\.?\d*|\.\d+)$/.test(t)) {
      const so = Number(t);
      if (thamChieu && /^\d+$/.test(t)) {
        const giu = this.i;
        this.boQua();
        const g = this.tu();
        if (/^\d+$/.test(g)) { this.boQua(); if (this.s[this.i] === "R" && (this.i + 1 >= s.length || KHOANG_TRANG.has(s.charCodeAt(this.i + 1)) || PHAN_CACH.has(s.charCodeAt(this.i + 1)))) { this.i++; return { r: so }; } }
        this.i = giu;
      }
      return so;
    }
    if (t === "true") return true;
    if (t === "false") return false;
    if (t === "null") return null;
    return { o: t };
  }
  chuoiThuong(): string {
    const s = this.s;
    this.i++; // (
    let sau = 1, out = "";
    while (this.i < s.length) {
      const c = s[this.i++]!;
      if (c === "\\") {
        const e = s[this.i++] ?? "";
        if (e === "n") out += "\n"; else if (e === "r") out += "\r"; else if (e === "t") out += "\t"; else if (e === "b") out += "\b"; else if (e === "f") out += "\f";
        else if (e === "\r") { if (s[this.i] === "\n") this.i++; } else if (e === "\n") { /* nối dòng */ }
        else if (/[0-7]/.test(e)) { let o = e; while (o.length < 3 && /[0-7]/.test(s[this.i] ?? "")) o += s[this.i++]; out += String.fromCharCode(parseInt(o, 8) & 0xff); }
        else out += e;
        continue;
      }
      if (c === "(") sau++;
      else if (c === ")") { sau--; if (!sau) return out; }
      out += c;
    }
    throw new Error("chuỗi không đóng");
  }
}

// ---------------- đối tượng của tệp ----------------
interface DoiTuong { v: GiaTri; luong?: Uint8Array }

// Node (máy chủ Boss đọc tệp, bộ test): zlib gốc có maxOutputLength — dừng NGAY khi vượt hạn, nhanh hơn DecompressionStream đọc từng
// mảnh ~64 KB tới 60 MB (bom giải nén từng mất > 15 s khi máy bận). Tên mô-đun để trong biến: bản dựng cho trình duyệt không kéo node:zlib.
type ZlibNode = { inflateSync: (b: Uint8Array, o: object) => Uint8Array; inflateRawSync: (b: Uint8Array, o: object) => Uint8Array; constants: { Z_SYNC_FLUSH: number } };
let zlibNode: Promise<ZlibNode | null> | undefined;
function layZlibNode(): Promise<ZlibNode | null> {
  const ten = "node:zlib";
  zlibNode ??= typeof process !== "undefined" && process.versions?.node
    ? (import(/* @vite-ignore */ ten) as Promise<ZlibNode>).catch(() => null)
    : Promise.resolve(null);
  return zlibNode;
}

async function giaiNenFlate(b: Uint8Array, conLai: { n: number }, kieu: "deflate" | "deflate-raw" = "deflate"): Promise<Uint8Array> {
  const z = await layZlibNode();
  if (z) {
    try {
      // Z_SYNC_FLUSH: luồng thiếu đuôi/kiểm tổng (hay gặp ở PDF) vẫn trả phần đã giải, như nhánh DecompressionStream bên dưới.
      const o = { maxOutputLength: conLai.n + 1, finishFlush: z.constants.Z_SYNC_FLUSH };
      const out = kieu === "deflate" ? z.inflateSync(b, o) : z.inflateRawSync(b, o);
      if (out.length > conLai.n) throw new LoiTaiLieu("bom");
      if (out.length || kieu === "deflate-raw") { conLai.n -= out.length; return new Uint8Array(out.buffer, out.byteOffset, out.length); }
    } catch (e) {
      if (e instanceof LoiTaiLieu) throw e;
      if ((e as { code?: string })?.code === "ERR_BUFFER_TOO_LARGE" || e instanceof RangeError) throw new LoiTaiLieu("bom");
      // lỗi khác (luồng hỏng giữa chừng…) → đi nhánh DecompressionStream để giữ đúng cách xử lý cũ (dùng phần đã giải, thử deflate thô)
    }
  }
  const ds = new DecompressionStream(kieu);
  const w = ds.writable.getWriter();
  w.write(new Uint8Array(b)).catch(() => undefined);
  w.close().catch(() => undefined);
  const r = ds.readable.getReader();
  const phan: Uint8Array[] = [];
  let tong = 0;
  try {
    for (;;) {
      const { done, value } = await r.read();
      if (done) break;
      tong += value.length;
      if (tong > conLai.n) { r.cancel().catch(() => undefined); throw new LoiTaiLieu("bom"); }
      phan.push(value);
    }
  } catch (e) {
    if (e instanceof LoiTaiLieu) throw e;
    // Luồng zlib thiếu đuôi/kiểm tổng (hay gặp ở PDF) nhưng đã ra chữ → dùng phần đã giải; không ra gì → thử deflate thô một lần.
    if (!phan.length) { if (kieu === "deflate") return giaiNenFlate(b, conLai, "deflate-raw"); throw e; }
  }
  conLai.n -= tong;
  const out = new Uint8Array(tong);
  let o = 0;
  for (const p of phan) { out.set(p, o); o += p.length; }
  return out;
}

const latin1 = (b: Uint8Array): string => new TextDecoder("latin1").decode(b);
// Byte → chuỗi latin1 1-1 (TextDecoder "latin1" thật ra là windows-1252: 0x80–0x9F bị đổi ký tự) — dùng khi cần giữ đúng byte.
function byteThanhChu(b: Uint8Array): string {
  let s = "";
  for (let i = 0; i < b.length; i += 8192) s += String.fromCharCode(...b.subarray(i, i + 8192));
  return s;
}

class TepPdf {
  dt = new Map<number, DoiTuong>();
  trailer: Record<string, GiaTri> = {};
  conLai = { n: GIAI_NEN_TONG_TOI_DA };
  coAnh = false;
  constructor(public byte: Uint8Array, public s: string) {}

  quetDoiTuong(): void {
    const s = this.s;
    const re = /(\d+)\s+(\d+)\s+obj\b/g;
    let m: RegExpExecArray | null;
    while ((m = re.exec(s))) {
      const so = Number(m[1]);
      const dt = new DocTu(s, m.index + m[0].length);
      let v: GiaTri | undefined;
      try { v = dt.giaTri(); } catch { continue; }
      if (v === undefined) break;
      let ketThuc = dt.i;
      let luong: Uint8Array | undefined;
      dt.boQua();
      if (s.startsWith("stream", dt.i) && laTuDien(v)) {
        let a = dt.i + 6;
        if (s[a] === "\r") a++;
        if (s[a] === "\n") a++;
        const dai = v.d.Length;
        let b = -1;
        if (typeof dai === "number" && dai >= 0 && a + dai <= s.length && /^\s*endstream/.test(s.slice(a + dai, a + dai + 20))) b = a + dai;
        else {
          const e = s.indexOf("endstream", a);
          if (e < 0) throw new Error("luồng không có endstream (tệp bị cắt cụt)");
          b = e;
          while (b > a && (s[b - 1] === "\n" || s[b - 1] === "\r")) b--;
        }
        luong = this.byte.subarray(a, b);
        ketThuc = b;
      }
      const het = s.indexOf("endobj", ketThuc);
      this.dt.set(so, { v, luong });
      if (laTuDien(v) && laTen(v.d.Subtype) && v.d.Subtype.n === "Image") this.coAnh = true;
      if (laTuDien(v) && laTen(v.d.Type) && v.d.Type.n === "XRef") Object.assign(this.trailer, v.d);
      re.lastIndex = het >= 0 ? het + 6 : ketThuc;
    }
    // trailer cổ điển (có thể nhiều lần — cập nhật nối tiếp): gộp, bản sau thắng.
    for (let i = s.indexOf("trailer"); i >= 0; i = s.indexOf("trailer", i + 7)) {
      try { const v = new DocTu(s, i + 7).giaTri(); if (laTuDien(v)) Object.assign(this.trailer, v.d); } catch { /* trailer hỏng → bỏ */ }
    }
  }

  async moLuongDoiTuong(): Promise<void> {
    for (const [, o] of [...this.dt]) {
      if (!laTuDien(o.v) || !laTen(o.v.d.Type) || o.v.d.Type.n !== "ObjStm" || !o.luong) continue;
      let b: Uint8Array;
      try { b = await this.giaiLuong(o); } catch (e) { if (e instanceof LoiTaiLieu) throw e; continue; }
      const s = byteThanhChu(b);
      const n = Number(this.lay(o.v.d.N)), dau = Number(this.lay(o.v.d.First));
      if (!Number.isInteger(n) || !Number.isInteger(dau)) continue;
      const dt = new DocTu(s);
      const cap: [number, number][] = [];
      for (let i = 0; i < n; i++) { const a = dt.giaTri(false), c = dt.giaTri(false); if (typeof a !== "number" || typeof c !== "number") break; cap.push([a, c]); }
      for (const [so, viTri] of cap) {
        if (this.dt.has(so)) continue; // đối tượng trực tiếp (thường là bản cập nhật sau) thắng
        try { const v = new DocTu(s, dau + viTri).giaTri(); if (v !== undefined) this.dt.set(so, { v }); } catch { /* bỏ đối tượng hỏng */ }
      }
    }
  }

  lay(v: GiaTri | undefined, sau = 0): GiaTri | undefined {
    if (laThamChieu(v) && sau < 32) return this.lay(this.dt.get(v.r)?.v, sau + 1);
    return v;
  }
  tuDien(v: GiaTri | undefined): Record<string, GiaTri> | null { const x = this.lay(v); return laTuDien(x) ? x.d : null; }

  async giaiLuong(o: DoiTuong): Promise<Uint8Array> {
    if (!o.luong) return new Uint8Array(0);
    const d = laTuDien(o.v) ? o.v.d : {};
    const loc = this.lay(d.Filter);
    const ds = (Array.isArray(loc) ? loc : loc === undefined || loc === null ? [] : [loc]).map((x) => { const t = this.lay(x); return laTen(t) ? t.n : ""; });
    let b = o.luong;
    for (const f of ds) {
      if (f === "FlateDecode" || f === "Fl") b = await giaiNenFlate(b, this.conLai);
      else if (f === "ASCIIHexDecode" || f === "AHx") { const h = latin1(b).replace(/>[\s\S]*$/, "").replace(/[^0-9a-fA-F]/g, ""); const out = new Uint8Array(Math.ceil(h.length / 2)); for (let i = 0; i < out.length; i++) out[i] = parseInt((h.slice(i * 2, i * 2 + 2) + "0").slice(0, 2), 16); b = out; }
      else throw new Error(`bộ lọc ${f} chưa hỗ trợ`);
    }
    return b;
  }
}

// ---------------- phông ----------------
interface Phong { soByte: 1 | 2; banDo: Map<number, string> | null; rong: (ma: number) => number; type3: number; donGian: boolean }

function docCMap(s: string): { banDo: Map<number, string>; soByte: number } {
  const banDo = new Map<number, string>();
  let soByte = 0;
  const utf16 = (b: string): string => { let out = ""; for (let i = 0; i + 1 < b.length; i += 2) out += String.fromCharCode((b.charCodeAt(i) << 8) | b.charCodeAt(i + 1)); return out; };
  const maSo = (b: string): number => { let n = 0; for (let i = 0; i < b.length; i++) n = n * 256 + b.charCodeAt(i); return n; };
  const dt = new DocTu(s);
  let che = "";
  const cho: GiaTri[] = [];
  for (let vong = 0; vong < 2_000_000; vong++) {
    let v: GiaTri | undefined;
    try { v = dt.giaTri(false); } catch { break; }
    if (v === undefined) break;
    if (laLenh(v)) {
      if (v.o === "begincodespacerange" || v.o === "beginbfchar" || v.o === "beginbfrange") { che = v.o; cho.length = 0; continue; }
      if (v.o === "endcodespacerange") { for (const x of cho) if (laChuoi(x)) soByte = Math.max(soByte, x.s.length); }
      else if (v.o === "endbfchar") { for (let i = 0; i + 1 < cho.length; i += 2) { const a = cho[i], b = cho[i + 1]; if (laChuoi(a) && laChuoi(b)) banDo.set(maSo(a.s), utf16(b.s)); } }
      else if (v.o === "endbfrange") {
        for (let i = 0; i + 2 < cho.length; i += 3) {
          const a = cho[i], b = cho[i + 1], c = cho[i + 2];
          if (!laChuoi(a) || !laChuoi(b)) continue;
          const lo = maSo(a.s), hi = Math.min(maSo(b.s), lo + 65535);
          if (Array.isArray(c)) c.forEach((x, k) => { if (laChuoi(x) && lo + k <= hi) banDo.set(lo + k, utf16(x.s)); });
          else if (laChuoi(c)) { const goc = utf16(c.s); for (let m = lo; m <= hi; m++) banDo.set(m, goc.slice(0, -1) + String.fromCharCode(goc.charCodeAt(goc.length - 1) + (m - lo))); }
        }
      }
      che = "";
      cho.length = 0;
      continue;
    }
    if (che) cho.push(v);
  }
  return { banDo, soByte };
}

async function taoPhong(tep: TepPdf, v: GiaTri | undefined): Promise<Phong> {
  const d = tep.tuDien(v) ?? {};
  const loai = laTen(tep.lay(d.Subtype)) ? (tep.lay(d.Subtype) as Ten).n : "";
  const ghep = loai === "Type0";
  let banDo: Map<number, string> | null = null;
  let soByte: 1 | 2 = ghep ? 2 : 1;
  const tu = d.ToUnicode;
  const o = laThamChieu(tu) ? tep.dt.get(tu.r) : undefined;
  if (o?.luong) {
    try { const c = docCMap(byteThanhChu(await tep.giaiLuong(o))); banDo = c.banDo; if (ghep && c.soByte === 1) soByte = 1; }
    catch (e) { if (e instanceof LoiTaiLieu) throw e; }
  }
  // Bề rộng chữ (đơn vị 1/1000 cỡ chữ; Type3 nhân FontMatrix) — chỉ để quyết có chèn dấu cách giữa hai đoạn chữ.
  const rongMa = new Map<number, number>();
  let macDinh = 500;
  let type3 = 0;
  if (ghep) {
    const con = tep.lay(d.DescendantFonts);
    const cd = tep.tuDien(Array.isArray(con) ? con[0] : undefined) ?? {};
    const dw = tep.lay(cd.DW);
    macDinh = typeof dw === "number" ? dw : 1000;
    const w = tep.lay(cd.W);
    if (Array.isArray(w)) {
      for (let i = 0; i < w.length;) {
        const a = tep.lay(w[i]), b = tep.lay(w[i + 1]);
        if (typeof a !== "number") break;
        if (Array.isArray(b)) { b.forEach((x, k) => { const y = tep.lay(x); if (typeof y === "number" && k < 65536) rongMa.set(a + k, y); }); i += 2; }
        else { const c = tep.lay(w[i + 2]); if (typeof b === "number" && typeof c === "number") for (let m = a; m <= Math.min(b, a + 65535); m++) rongMa.set(m, c); i += 3; }
      }
    }
  } else {
    const fc = tep.lay(d.FirstChar), ws = tep.lay(d.Widths);
    if (typeof fc === "number" && Array.isArray(ws)) ws.forEach((x, k) => { const y = tep.lay(x); if (typeof y === "number") rongMa.set(fc + k, y); });
    if (loai === "Type3") { const fm = tep.lay(d.FontMatrix); const a = Array.isArray(fm) ? tep.lay(fm[0]) : undefined; type3 = typeof a === "number" ? a : 0.001; macDinh = 0; }
  }
  return { soByte, banDo, rong: (m) => rongMa.get(m) ?? macDinh, type3, donGian: !ghep };
}

const CP1252 = new TextDecoder("windows-1252");
function giaiMaChuoi(p: Phong | undefined, b: string): { chu: string; ma: number[] } {
  const ma: number[] = [];
  const n = p?.soByte ?? 1;
  for (let i = 0; i + n - 1 < b.length; i += n) ma.push(n === 2 ? (b.charCodeAt(i) << 8) | b.charCodeAt(i + 1) : b.charCodeAt(i));
  let chu = "";
  for (const m of ma) {
    const u = p?.banDo?.get(m);
    if (u !== undefined) chu += u;
    else if (!p || p.donGian) chu += CP1252.decode(new Uint8Array([m & 0xff]));
    // phông ghép không có bảng ToUnicode: không đoán được chữ → bỏ (không trả chữ rác)
  }
  return { chu, ma };
}

// ---------------- nội dung trang ----------------
interface TrangThaiChu { tm: number[]; tlm: number[]; tc: number; tw: number; th: number; tl: number; tfs: number; phong?: Phong }

async function chuCuaNoiDung(tep: TepPdf, noiDung: string, phongCua: (ten: string) => Promise<Phong | undefined>, out: { dong: string[]; cur: string; y: number | null; x: number | null; tfs: number }): Promise<void> {
  const dt = new DocTu(noiDung);
  const st: TrangThaiChu = { tm: [1, 0, 0, 1, 0, 0], tlm: [1, 0, 0, 1, 0, 0], tc: 0, tw: 0, th: 1, tl: 0, tfs: 12 };
  const ngan: TrangThaiChu[] = [];
  const toan: GiaTri[] = [];
  const xuongDong = (): void => { out.dong.push(out.cur); out.cur = ""; out.x = null; };
  const datTm = (m: number[]): void => { st.tm = m.slice(); st.tlm = m.slice(); };
  const ve = (b: string): void => {
    const p = st.phong;
    const { chu, ma } = giaiMaChuoi(p, b);
    const x = st.tm[4]!, y = st.tm[5]!;
    const coChu = Math.abs(st.tfs * (st.tm[3]! || st.tm[0]! || 1)) || 1;
    if (out.y !== null && Math.abs(y - out.y) > coChu * 0.4) xuongDong();
    else if (out.x !== null && out.cur && !/\s$/.test(out.cur) && !/^\s/.test(chu) && x - out.x > coChu * 0.2) out.cur += " ";
    out.cur += chu;
    // tiến theo bề rộng chữ (+ khoảng giữa ký tự/từ; số trong TJ đã cộng trước khi gọi ve)
    let tien = 0;
    for (const m of ma) {
      const w = p ? (p.type3 ? p.rong(m) * p.type3 : p.rong(m) / 1000) : 0.5;
      tien += (w * st.tfs + st.tc + (m === 32 && (p?.soByte ?? 1) === 1 ? st.tw : 0)) * st.th;
    }
    st.tm[4] = x + tien * st.tm[0]!;
    st.tm[5] = y + tien * st.tm[1]!;
    out.x = st.tm[4]; out.y = st.tm[5]; out.tfs = coChu;
  };
  const tienTJ = (n: number): void => {
    const t = (-n / 1000) * st.tfs * st.th;
    // khoảng âm lớn trong TJ = dấu cách (LaTeX/Word hay viết thế, không có ký tự cách)
    if (n < -180 && out.cur && !/\s$/.test(out.cur)) out.cur += " ";
    st.tm[4] = st.tm[4]! + t * st.tm[0]!; st.tm[5] = st.tm[5]! + t * st.tm[1]!;
    out.x = st.tm[4];
  };
  const so = (i: number): number => { const v = toan[toan.length - i]; return typeof v === "number" ? v : 0; };
  for (let vong = 0; vong < 5_000_000; vong++) {
    let v: GiaTri | undefined;
    try { v = dt.giaTri(false); } catch { break; }
    if (v === undefined) break;
    if (!laLenh(v)) { toan.push(v); if (toan.length > 10_000) toan.splice(0, 5_000); continue; }
    switch (v.o) {
      case "BT": st.tm = [1, 0, 0, 1, 0, 0]; st.tlm = [1, 0, 0, 1, 0, 0]; break;
      case "q": ngan.push({ ...st, tm: st.tm.slice(), tlm: st.tlm.slice() }); if (ngan.length > 1000) ngan.shift(); break;
      case "Q": { const c = ngan.pop(); if (c) { st.tc = c.tc; st.tw = c.tw; st.th = c.th; st.tl = c.tl; st.tfs = c.tfs; st.phong = c.phong; } break; }
      case "Tf": { const ten = toan[toan.length - 2]; st.tfs = so(1); st.phong = laTen(ten) ? await phongCua(ten.n) : undefined; break; }
      case "Tc": st.tc = so(1); break;
      case "Tw": st.tw = so(1); break;
      case "Tz": st.th = so(1) / 100; break;
      case "TL": st.tl = so(1); break;
      case "Tm": datTm([so(6), so(5), so(4), so(3), so(2), so(1)]); break;
      case "Td": case "TD": {
        const tx = so(2), ty = so(1), m = st.tlm;
        if (v.o === "TD") st.tl = -ty;
        datTm([m[0]!, m[1]!, m[2]!, m[3]!, m[4]! + tx * m[0]! + ty * m[2]!, m[5]! + tx * m[1]! + ty * m[3]!]);
        break;
      }
      case "T*": { const m = st.tlm; datTm([m[0]!, m[1]!, m[2]!, m[3]!, m[4]! - st.tl * m[2]!, m[5]! - st.tl * m[3]!]); break; }
      case "Tj": { const s = toan[toan.length - 1]; if (laChuoi(s)) ve(s.s); break; }
      case "'": case "\"": {
        if (v.o === "\"") { st.tw = so(3); st.tc = so(2); }
        const m = st.tlm; datTm([m[0]!, m[1]!, m[2]!, m[3]!, m[4]! - st.tl * m[2]!, m[5]! - st.tl * m[3]!]);
        const s = toan[toan.length - 1]; if (laChuoi(s)) ve(s.s);
        break;
      }
      case "TJ": { const a = toan[toan.length - 1]; if (Array.isArray(a)) for (const x of a) { if (laChuoi(x)) ve(x.s); else if (typeof x === "number") tienTJ(x); } break; }
      case "BI": { // ảnh nhúng trong nội dung: bỏ qua phần nhị phân tới EI
        tep.coAnh = true;
        const id = noiDung.indexOf("ID", dt.i);
        const ei = id < 0 ? -1 : noiDung.slice(id + 3).search(/\sEI(\s|$)/);
        dt.i = id < 0 || ei < 0 ? noiDung.length : id + 3 + ei + 3;
        break;
      }
      case "Do": { const t = toan[toan.length - 1]; if (laTen(t)) await phongCua(`\u0000xobj:${t.n}`); break; }
      default: break;
    }
    toan.length = 0;
  }
}

async function chuCuaTrang(tep: TepPdf, trang: Record<string, GiaTri>, out: { dong: string[]; cur: string; y: number | null; x: number | null; tfs: number }, daDocForm: Set<number>, sau = 0): Promise<void> {
  // Tài nguyên kế thừa theo cây trang (/Parent)
  let tn: Record<string, GiaTri> | null = null;
  for (let p: Record<string, GiaTri> | null = trang, k = 0; p && k < 64; p = tep.tuDien(p.Parent), k++) { tn = tep.tuDien(p.Resources); if (tn) break; }
  const phongDs = tep.tuDien(tn?.Font) ?? {};
  const xobj = tep.tuDien(tn?.XObject) ?? {};
  const daCo = new Map<string, Phong | undefined>();
  const phongCua = async (ten: string): Promise<Phong | undefined> => {
    if (ten.startsWith("\u0000xobj:")) { // XObject dạng Form có thể chứa chữ (bảng, khung) → đọc như trang con
      const r = xobj[ten.slice(6)];
      if (!laThamChieu(r) || daDocForm.has(r.r) || sau > 8) return undefined;
      const o = tep.dt.get(r.r);
      const d = o && laTuDien(o.v) ? o.v.d : null;
      if (!d) return undefined;
      const st = tep.lay(d.Subtype);
      if (laTen(st) && st.n === "Image") { tep.coAnh = true; return undefined; }
      if (!laTen(st) || st.n !== "Form") return undefined;
      daDocForm.add(r.r);
      try { await chuCuaNoiDungDoiTuong(tep, o!, { ...d, Parent: null as unknown as GiaTri, Resources: d.Resources ?? (tn ? { d: tn } : null) }, out, daDocForm, sau + 1); } catch (e) { if (e instanceof LoiTaiLieu) throw e; }
      return undefined;
    }
    if (daCo.has(ten)) return daCo.get(ten);
    const f = phongDs[ten] !== undefined ? await taoPhong(tep, phongDs[ten]) : undefined;
    daCo.set(ten, f);
    return f;
  };
  const nd = tep.lay(trang.Contents);
  const ds = Array.isArray(nd) ? nd : [trang.Contents];
  let chu = "";
  for (const x of ds) {
    const o = laThamChieu(x) ? tep.dt.get(x.r) : undefined;
    if (!o?.luong) continue;
    try { chu += byteThanhChu(await tep.giaiLuong(o)) + "\n"; } catch (e) { if (e instanceof LoiTaiLieu) throw e; }
  }
  await chuCuaNoiDung(tep, chu, phongCua, out);
}

async function chuCuaNoiDungDoiTuong(tep: TepPdf, o: DoiTuong, d: Record<string, GiaTri>, out: { dong: string[]; cur: string; y: number | null; x: number | null; tfs: number }, daDocForm: Set<number>, sau: number): Promise<void> {
  const tn = tep.tuDien(d.Resources);
  const trangGia: Record<string, GiaTri> = { Resources: tn ? { d: tn } : null, Contents: [] };
  const so = -1 - daDocForm.size; // số giả cho đối tượng tạm
  tep.dt.set(so, o);
  (trangGia.Contents as GiaTri[]).push({ r: so });
  try { await chuCuaTrang(tep, trangGia, out, daDocForm, sau); } finally { tep.dt.delete(so); }
}

function danhSachTrang(tep: TepPdf): Record<string, GiaTri>[] {
  const out: Record<string, GiaTri>[] = [];
  const daQua = new Set<number>();
  const di = (v: GiaTri | undefined, sau: number): void => {
    if (out.length >= TRANG_TOI_DA || sau > 64) return;
    if (laThamChieu(v)) { if (daQua.has(v.r)) return; daQua.add(v.r); }
    const d = tep.tuDien(v);
    if (!d) return;
    const loai = tep.lay(d.Type);
    const kids = tep.lay(d.Kids);
    if (Array.isArray(kids) && (!laTen(loai) || loai.n === "Pages")) { for (const k of kids) di(k, sau + 1); return; }
    if (laTen(loai) && loai.n === "Page") out.push(d);
    else if (!loai && d.Contents !== undefined) out.push(d);
  };
  const goc = tep.tuDien(tep.trailer.Root);
  if (goc) di(goc.Pages, 0);
  if (!out.length) { // cây trang hỏng → lấy mọi /Type /Page theo thứ tự số đối tượng
    for (const [, o] of [...tep.dt].sort((a, b) => a[0] - b[0])) {
      if (laTuDien(o.v) && laTen(o.v.d.Type) && o.v.d.Type.n === "Page") out.push(o.v.d);
      if (out.length >= TRANG_TOI_DA) break;
    }
  }
  return out;
}

export async function chuTuPdf(ten: string, data: Uint8Array): Promise<string> {
  const s = byteThanhChu(data);
  const tep = new TepPdf(data, s);
  try {
    tep.quetDoiTuong();
    if (tep.trailer.Encrypt !== undefined || /\/Encrypt\s*(\d+\s+\d+\s+R|<<)/.test(s.slice(-4096))) throw new LoiTaiLieu(`'${ten}' có mật khẩu hoặc bị khoá (mã hoá) — mở bằng trình đọc PDF, lưu lại bản không mật khẩu rồi tải lên`);
    if (!tep.dt.size) throw new Error("không thấy đối tượng nào");
    await tep.moLuongDoiTuong();
    const trang = danhSachTrang(tep);
    if (!trang.length) throw new Error("không thấy trang nào");
    const out = { dong: [] as string[], cur: "", y: null as number | null, x: null as number | null, tfs: 12 };
    const daDocForm = new Set<number>();
    for (const t of trang) {
      await chuCuaTrang(tep, t, out, daDocForm);
      out.dong.push(out.cur, ""); out.cur = ""; out.y = null; out.x = null;
    }
    const chu = out.dong.join("\n").replace(/[ \t]+$/gm, "").replace(/\n{3,}/g, "\n\n").trim();
    if (!chu.replace(/\s/g, "")) {
      if (tep.coAnh) throw new LoiTaiLieu(`'${ten}' là PDF ảnh quét (không có lớp chữ) — hãy chụp/xuất các trang thành ẢNH rồi tải ảnh lên (AI đọc ảnh), hoặc dán chữ vào ô tài liệu`);
      throw new LoiTaiLieu(`'${ten}' không có chữ nào đọc được`);
    }
    return chu;
  } catch (e) {
    if (e instanceof LoiTaiLieu) {
      if (e.message === "bom") throw new LoiTaiLieu(`'${ten}' có phần nội dung quá lớn khi giải nén (trên ${GIAI_NEN_TONG_TOI_DA / 1048576} MB) — tệp hỏng hoặc không an toàn`);
      throw e;
    }
    throw new LoiTaiLieu(`'${ten}' là PDF bị hỏng hoặc không đọc được (${e instanceof Error ? e.message : String(e)})`);
  }
}
